module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/close@3x-0fd7a492fd37b1c4261d84cc879ca15e.png";